import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-appointments',
  templateUrl: './turns-appointments.component.html',
  styleUrls: ['./turns-appointments.component.scss']
})
export class TurnsAppointmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
